<div class="header-container">
    <div class="mobile-view">
        <div class="mobile-container">
            <div class="logo">
                <img src="../../assets/images/capvizon_logo_ylw.png" alt="">
            </div>
            <div class="menu-mobile" (click)="onMobileMenu()">
                <div class="menu-icon menu-icon1"></div>
                <div class="menu-icon menu-icon2"></div>
                <div class="menu-icon menu-icon3"></div>
            </div>
        </div>
    </div>
    <div class="desktop-view">
        <div class="desktop-container">
            <div class="brand">
                <!-- <h3 class="brand-name">Capvizon</h3> -->
                <img class="brand-name" src="../../assets/images/capvizon_brand_logo.png" alt="">
            </div>
            <div class="menu">
                <div class="menu-list active" [routerLink]="'/LandingPage/Home'">Home</div>
                <div class="menu-list" [routerLink]="'/LandingPage/AboutUs'">About us</div>
            </div>
            <div class="sign">
                <ccdl-button [btnLabel]="'Sign In'" [btnType]="signInBtnType" (onClick)="signInClick()"></ccdl-button>
                <ccdl-button [btnLabel]="'Sign up'" [btnType]="signUpBtnType" (onClick)="signUpClick()"></ccdl-button>
            </div>
        </div>
    </div>
</div>
